import React from "react";
import PropTypes from 'prop-types';
import {
    TextField
} from "@material-ui/core";

const PhoneField = props => (
    <TextField
        readOnly
        fullWidth
        {...props}
        value={props.value.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}
    />
);

PhoneField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default PhoneField;
